import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

export interface StatusItem {
  id: number;
  status_code: number;
  status_desc: string;
}
@Injectable({
  providedIn: 'root',
})
export class StatusResolverService extends ApiService {
  public getStatusData(): Observable<any> {
    return this.get<any>(ROUTES.GET_STATUS_RESOLVER, {});
  }

   private statusMap = new Map<number, StatusItem>();

  setStatuses(statuses: StatusItem[]): void {
    this.statusMap.clear();

    statuses.forEach(item => {
      this.statusMap.set(item.status_code, item);
    });
  }

  getStatus(id: number): StatusItem | undefined {
    return this.statusMap.get(id);
  }

  getStatusName(id: number): number | undefined {
    return this.statusMap.get(id)?.status_code;
  }

  getStatusCode(id: number): string | undefined {
    return this.statusMap.get(id)?.status_desc;
  }
}
